// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletQuickLinksCard_wql__aYojK {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  background-size: cover;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  height: fit-content;
}
@media only screen and (max-width: 62.5em) {
  .WalletQuickLinksCard_wql__aYojK {
    padding: 2rem;
  }
}
.WalletQuickLinksCard_wql__links__TI1GI {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .WalletQuickLinksCard_wql__links__TI1GI {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .WalletQuickLinksCard_wql__links__TI1GI {
    grid-template-columns: repeat(2, 1fr);
  }
}
.WalletQuickLinksCard_wql__links_item__fJ6xp {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3rem;
  gap: 1rem;
  border: 1px solid var(--color-grey);
  border-radius: 1rem;
  box-sizing: border-box;
  width: 100%;
  height: 10rem;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
}
.WalletQuickLinksCard_wql__links_item__fJ6xp:hover {
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  transform: translateX(3px) translateY(3px);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-primary-3);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/WalletQuickLinksCard.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,SAAA;EACA,4CAAA;EACA,mBAAA;AADD;AAGC;EAbD;IAcE,aAAA;EAAA;AACF;AAEC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AAAF;AAEE;EAND;IAOE,qCAAA;EACD;AACF;AACE;EAVD;IAWE,qCAAA;EAED;AACF;AAAE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mCAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;AAEH;AAAG;EACC,sCAAA;EACA,2BAAA;EACA,0CAAA;EACA,4CAAA;EACA,wCAAA;AAEJ","sourcesContent":["@import '../variables/breakpoints';\n\n.wql {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tbox-sizing: border-box;\n\tpadding: 3rem 5rem 3rem 5rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-white);\n\tbackground-size: cover;\n\tgap: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\theight: fit-content;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tpadding: 2rem;\n\t}\n\n\t&__links {\n\t\tdisplay: grid;\t\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 1rem;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t\t\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_item {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tgap: 1rem;\n\t\t\tborder: 1px solid var(--color-grey);\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-sizing: border-box;\n\t\t\twidth: 100%;\n\t\t\theight: 10rem;\n\t\t\tjustify-content: center;\n\t\t\ttransition: all 0.4s;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tborder: 2px solid var(--color-primary);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\ttransform: translateX(3px) translateY(3px);\n\t\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wql": `WalletQuickLinksCard_wql__aYojK`,
	"wql__links": `WalletQuickLinksCard_wql__links__TI1GI`,
	"wql__links_item": `WalletQuickLinksCard_wql__links_item__fJ6xp`
};
export default ___CSS_LOADER_EXPORT___;
